import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { UniFormFieldModule, UniInputModule, UniSelectModule } from "@universal-ui";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";

import { FormSharedModule } from "@shared/FormShared/form-shared.module";
import { SharedModule } from "@shared/Modules/shared.module";

import { ClientTypeFormComponent } from "./Components/ClientTypeForm/clientType-form.component";
import { IdentificationFormComponent } from "./Components/IdentificationForm/identification-form.component";
import { NameFormComponent } from "./Components/NameForm/name-form.component";
import { PolicyFormComponent } from "./Components/PolicyForm/policy-form.component";
import { BrandNamePipe } from "./Pipes/brand-name.pipe";
import { ColorNamePipe } from "./Pipes/color-name.pipe";
import { CurrencyNamePipe } from "./Pipes/currency-name.pipe";
import { FullIdentificationPipe } from "./Pipes/full-identification.pipe";
import { IdentificationTypePipe } from "./Pipes/identification-type.pipe";
import { ModelNamePipe } from "./Pipes/model-name.pipe";
import { VersionNamePipe } from "./Pipes/version-name.pipe";

@NgModule({
  declarations: [
    PolicyFormComponent,
    IdentificationFormComponent,
    ClientTypeFormComponent,
    IdentificationTypePipe,
    FullIdentificationPipe,
    BrandNamePipe,
    ModelNamePipe,
    VersionNamePipe,
    ColorNamePipe,
    CurrencyNamePipe,
    NameFormComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    UniFormFieldModule,
    UniInputModule,
    UniSelectModule,
    NgxMaskDirective,
    NgxMaskPipe,
  ],
  exports: [
    PolicyFormComponent,
    IdentificationFormComponent,
    ClientTypeFormComponent,
    SharedModule,
    FormSharedModule,
    IdentificationTypePipe,
    FullIdentificationPipe,
    BrandNamePipe,
    ModelNamePipe,
    VersionNamePipe,
    ColorNamePipe,
    CurrencyNamePipe,
    NameFormComponent,
  ],
  providers: [provideNgxMask({ validation: true })],
})
export class RGSVISharedModule {}
